import { NumberInput } from 'alkali'

const TEXT_INPUT_CHANGE_EVENTS = [
	'change',
	'propertychange',
	'click',
	'keyup',
	'input',
	'paste',
]
export default NumberInput('.form-control', {
	inputEvents: TEXT_INPUT_CHANGE_EVENTS,
})
